/**
 * Derives a stable `topic_key` for a knowledge-base topic from its name.
 *
 * Mirror of fountain-ai's knowledge-base-topic-key.util.ts — the backend
 * upserts faq rows by (tenant, knowledge_base_id, topic_key), so the SAME
 * normalization rules must produce the same key on both sides (HRAI-2022).
 *
 * Normalization: lowercase, non-alphanumeric runs -> `_`, trim leading/trailing
 * `_`, capped at 256 chars (the `faq.topic_key` column width).
 *
 * Returns `undefined` for empty/punctuation-only names so callers leave
 * `topic_key` unset rather than sending an empty key.
 */
export function deriveTopicKey(name: string): string | undefined {
  const key = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 256);
  return key.length > 0 ? key : undefined;
}
